import SentryService from './Sentry';

export default SentryService;
